<template>
    <Header
        :title="title"
        :cypress-id="cypressId"
        :level="2"
        :bordered="bordered"
        :with-tooltip="withTooltip"
    >
        <template
            v-if="hasBeforeTitleContentSlot"
            #before-title-content
        >
            <slot name="before-title-content" />
        </template>
        <template
            v-if="hasTitleIconSlot"
            #left-slot
        >
            <div
                class="title-icon"
            >
                <slot name="title-icon" />
            </div>
        </template>
        <template #after-title-content>
            <slot name="after-title-content" />
        </template>

        <template
            v-if="hasNavigationSlot"
            #navigation
        >
            <slot name="navigation" />
        </template>

        <template #right-slot>
            <slot
                name="right-slot-desktop"
            />
        </template>
    </Header>
</template>

<script lang="ts" setup>
import { computed, useSlots } from 'vue';
import Header from './Header.vue';

type Props = {
    title: string,
    cypressId?: string | null,
    withTooltip?: boolean,
    bordered?: boolean,

}

withDefaults(defineProps<Props>(), {
    cypressId: null,
    withTooltip: false,
    bordered: true,
});

const slots = useSlots();

const hasTitleIconSlot = computed(() => !!slots['title-icon']);
const hasNavigationSlot = computed(() => !!slots.navigation);
const hasBeforeTitleContentSlot = computed(() => !!slots['before-title-content']);

</script>

<style lang="scss" scoped>
.title-icon {
    display: block;

    width: 1.25rem;
    height: 1.25rem;

    &:deep svg {
        display: block;

        width: 100%;
        height: 100%;

        fill: currentColor;
    }
}
</style>
